import React, { createContext, useContext, useState } from 'react';
import { Tarefa } from '../types';

interface ModalContextData {
  tarefaSelecionada: Tarefa | null;
  modalDetalhesAberto: boolean;
  modalNovaTarefaAberto: boolean;
  abrirModalDetalhes: (tarefa: Tarefa) => void;
  fecharModalDetalhes: () => void;
  abrirModalNovaTarefa: () => void;
  fecharModalNovaTarefa: () => void;
}

const ModalContext = createContext<ModalContextData>({} as ModalContextData);

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [tarefaSelecionada, setTarefaSelecionada] = useState<Tarefa | null>(null);
  const [modalDetalhesAberto, setModalDetalhesAberto] = useState(false);
  const [modalNovaTarefaAberto, setModalNovaTarefaAberto] = useState(false);

  const abrirModalDetalhes = (tarefa: Tarefa) => {
    setTarefaSelecionada(tarefa);
    setModalDetalhesAberto(true);
  };

  const fecharModalDetalhes = () => {
    setModalDetalhesAberto(false);
    setTarefaSelecionada(null);
  };

  const abrirModalNovaTarefa = () => {
    setModalNovaTarefaAberto(true);
  };

  const fecharModalNovaTarefa = () => {
    setModalNovaTarefaAberto(false);
  };

  return (
    <ModalContext.Provider
      value={{
        tarefaSelecionada,
        modalDetalhesAberto,
        modalNovaTarefaAberto,
        abrirModalDetalhes,
        fecharModalDetalhes,
        abrirModalNovaTarefa,
        fecharModalNovaTarefa
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal deve ser usado dentro de um ModalProvider');
  }
  return context;
};
